import { render, staticRenderFns } from "./outboundDataStatisticsReport.vue?vue&type=template&id=6f62518b&scoped=true&v-if=true&"
import script from "./outboundDataStatisticsReport.vue?vue&type=script&lang=ts&"
export * from "./outboundDataStatisticsReport.vue?vue&type=script&lang=ts&"
import style0 from "./outboundDataStatisticsReport.vue?vue&type=style&index=0&id=6f62518b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62518b",
  null
  
)

export default component.exports